import { ApiFactoryFacade } from './api-factory.facade';
import { ApiMockService } from './api-mock.service';
import { IApiConfig } from './api.interface';
import { Injectable } from '@angular/core';

@Injectable()
export class ApiMockFactoryService extends ApiFactoryFacade {
  create(config: IApiConfig) {
    return new ApiMockService(config);
  }
}
